import { MonthYear } from "@/types/monthYear";

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
};

export const parseBRL = (value: string): number => {
  const cleanValue = value.replace(/[^\d,]/g, "").replace(",", ".");
  return parseFloat(cleanValue) || 0;
};

export const getMonthYear = (date: Date): MonthYear => MonthYear.fromDate(date);

// Backwards-compatible name (now returns MonthYear class)
export const getMonthYearString = getMonthYear;

export const formatMonthYearDisplay = (monthYear: MonthYear): string =>
  monthYear.toDisplayPtBR();

export const getMonthsInRange = (
  start: MonthYear,
  end: MonthYear
): MonthYear[] => {
  const startDate = new Date(start.year, start.month - 1, 1);
  const endDate = new Date(end.year, end.month - 1, 1);
  const months: MonthYear[] = [];

  let current = new Date(startDate);
  while (current <= endDate) {
    months.push(MonthYear.fromDate(current));
    current.setMonth(current.getMonth() + 1);
  }

  return months;
};

export const getRelativeMonth = (monthsOffset: number): MonthYear => {
  const date = new Date();
  date.setMonth(date.getMonth() + monthsOffset);
  return MonthYear.fromDate(date);
};
